export default __webpack_public_path__ + "static/data-about-screenshot-1-3636b04ab936c1adefe99e868d021c4e.webp";